export const getAPI = (apiUrl, tokenInfo) => {

    return fetch(apiUrl, {
        method: "GET",
        headers: {
            Authorization: 'Bearer ' + tokenInfo.id_token,
            Principal: tokenInfo.access_token,
        },
        // headers: localHeader,
    });
}


export const postAPI = (apiUrl, fileFormData, tokenInfo) => {
    return fetch(apiUrl, {
        method: "POST",
        
        headers: {
            Authorization: 'Bearer ' + tokenInfo.id_token,
            Principal: tokenInfo.access_token,
        },
        // headers: localHeader,
        body: fileFormData
    });
}

export const deleteAPI = (apiUrl, tokenInfo, payload) => {
    const requestOptions = {
        method: "DELETE",
        headers: {
            Authorization: 'Bearer ' + tokenInfo.id_token,
            Principal: tokenInfo.access_token,
            "Content-Type": "application/json",
        },
        // headers: localHeader,
    };

    if (payload !== undefined) {
        requestOptions.body = payload;
    }

    return fetch(apiUrl, requestOptions);
}

export const putAPI = (apiUrl, tokenInfo, payload) => {
    const requestOptions = {
        method: "PUT",
        headers: {
            Authorization: 'Bearer ' + tokenInfo.id_token,
            Principal: tokenInfo.access_token,
            "Content-Type": "application/json",
        },
        // headers: localHeader,
    };

    if (payload !== undefined) {
        requestOptions.body = payload;
    }

    return fetch(apiUrl, requestOptions);
}
